import { useEffect, useState } from 'react';
import { useUIStore } from '@/store/uiStore';
import { useAuthStore } from '@/store/authStore';
import { useQueryClient } from '@tanstack/react-query';
import { playerApi } from '@/api/endpoints';
import { queryKeys } from '@/api/queryKeys';
import { haptic } from '@/lib/telegram';

export function BackstoryScreen() {
  const userId = useAuthStore((s) => s.userId);
  const setScreen = useUIStore((s) => s.setScreen);
  const queryClient = useQueryClient();
  const [backstory, setBackstory] = useState<string>('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!userId) return;
      try {
        const data = await playerApi.get(userId);
        if (!cancelled) {
          setBackstory(data.player?.backstory ?? '');
          queryClient.setQueryData(queryKeys.player(userId), data);
        }
      } catch {
        /* silent */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [userId, queryClient]);

  return (
    <div
      className="flex-1 overflow-y-auto p-6 cursor-pointer active:bg-bg-surface/30 transition"
      onClick={() => {
        haptic('medium');
        setScreen('main');
      }}
    >
      <div className="max-w-md mx-auto space-y-6 pt-6">
        <h1 className="font-display text-3xl text-center text-white">Твоя история</h1>
        <div className="text-white/90 leading-relaxed text-base whitespace-pre-wrap">
          {backstory || 'Загружаем твою предысторию...'}
        </div>
        <div className="text-white/40 text-center text-sm pt-4">Нажми, чтобы продолжить →</div>
      </div>
    </div>
  );
}
